import {
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTooltipPosition } from '../../enums/mat-tooltip-position';

@Component({
    selector: 'apcam-tooltip-custom',
    templateUrl: './tooltip-custom.component.html',
    styleUrls: ['./tooltip-custom.component.scss'],
    imports: [MatTooltipModule],
    encapsulation: ViewEncapsulation.None,
})
export class TooltipCustomComponent implements OnInit {
    /**
     * Required
     *
     * The message to be displayed in the tooltip
     */
    @Input({ required: true })
    customMatTooltip: string = '';

    /**
     * Disables the display of the tooltip.
     */
    @Input()
    customMatTooltipDisabled: boolean = false;

    /**
     * The default delay in ms before hiding the tooltip after hide is called.
     */
    @Input()
    customMatTooltipHideDelay: number = 0;

    /**
     * Allows the user to define the position of the tooltip relative to the parent element.
     *
     * @default MatTooltipPosition.ABOVE
     */
    @Input()
    customMatTooltipPosition: MatTooltipPosition = MatTooltipPosition.ABOVE;

    /**
     * Whether tooltip should be relative to the click or touch origin instead of outside the element bounding box.
     */
    @Input()
    customMatTooltipPositionAtOrigin: boolean = false;

    /**
     * The default delay in ms before showing the tooltip after show is called.
     */
    @Input()
    customMatTooltipShowDelay: number = 0;

    /**
     * Allows for a configuration of CSS style classes of the nested mat-tooltip-trigger element. Useful for styling
     * the text that is wrapped in the tooltip (e.g. ellipsis-overflow).
     */
    @Input()
    customTooltipStyle: string = '';

    /**
     * CSS property of outer div, on which the tooltip is applied.
     */
    @Input()
    display: 'inline-block' | 'block' | 'grid' | 'flex' = 'inline-block';

    /**
     * Color of tooltip - one of angular material color themes.
     */
    @Input()
    color: 'primary' | 'accent' | 'warn' = 'primary';

    CUSTOM_TOOLTIP_CLASS = 'custom-tooltip';

    customTooltipClass: string = '';

    constructor(private readonly cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        let colorClass: string;
        switch (this.color) {
            case 'primary':
                colorClass = 'custom-tooltip-primary';
                break;
            case 'accent':
                colorClass = 'custom-tooltip-accent';
                break;
            case 'warn':
                colorClass = 'custom-tooltip-warn';
                break;
        }

        this.customTooltipClass = `${this.CUSTOM_TOOLTIP_CLASS} ${colorClass}`;
        this.cdr.detectChanges();
    }
}
